import type { Placement } from "@floating-ui/react";
import type { ComponentChildren, JSX } from "preact";
import { Button } from "@gss/components/Button";
import { Help } from "@gss/components/icons";
import { Popover } from "@gss/components/Popover";
import "./ButtonHelp.css";
import { useTranslation } from "./Translation";

interface Props {
    popover: ComponentChildren | (() => ComponentChildren);
    disabled?: boolean;
    buttonText?: boolean;
    className?: string;
    placement?: Placement;
}

export function ButtonHelp({
    popover,
    buttonText,
    className,
    placement,
    ...rest
}: Props): JSX.Element {
    const t = useTranslation().translation.misc;
    const text = t.help;
    return (
        <Popover placement={placement} className="mw-100 p-3" overlay={popover}>
            <Button
                variant="default"
                small
                className={className}
                title={!buttonText ? text : undefined}
                aria-label={!buttonText ? text : undefined}
                {...rest}
            >
                <Help className="icon-help" aria-hidden /> {buttonText && text}
            </Button>
        </Popover>
    );
}
